import "@aws-amplify/ui-react/styles.css";
import { Box, Button, Center, Checkbox, Flex, Heading, Spacer, Table, TableCaption, TableContainer, Tbody, Td, Text, Tfoot, Th, Thead, Tr, VStack } from '@chakra-ui/react'
import React from "react";
import { ImageDescriptorData, PostDataExtended } from "../clients/data-service";
import BasePage from "../controls/BasePage";
import NavButton from "../controls/NavButton";
import { LoadingBlock } from "../controls/LoadingBlock";
import PageTitle from "../controls/PageTitle";
import * as dayjs from 'dayjs'
import { Link as ReactLink } from "react-router-dom";
import { OrderBy } from "../utilities/DataTools";
import { getUnreviewedDescriptors } from "../clients/photo-upload-client";
import { LoadingPage } from "../controls/LoadingPage";

const DescriptorsTable = ({imageDescriptors} :{ imageDescriptors: ImageDescriptorData[] }) => {

    imageDescriptors = OrderBy(imageDescriptors, p => new Date(p.created).getTime());

    const ensure = (text: string|undefined, fallback: string) => {
        if (text == null || text.length === 0) {
            return fallback;
        }
        return text;
    }
    return (
        <TableContainer>
            <Table variant='simple'>
                <Thead>
                    <Tr>
                        <Th w={100}>Date</Th>
                        <Th w={100}>Creator</Th>
                        <Th>Title</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {imageDescriptors.map(post => (
                        <Tr key={post.id}>
                            <Td>{dayjs(post.created).format('DD/MM/YYYY')}</Td>
                            <Td>{post.creator.user_name}</Td>
                            <Td><ReactLink to={`/review-submission/${post.id}`} >{ensure(post.name, "No Title")}</ReactLink></Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    )
}

class ManageSubmissions extends React.Component<{}, {unreviewedDescriptors?: ImageDescriptorData[]}> {
    constructor(props) {
        super(props);
        this.state = {};

        async function LoadData(comp) {
            const unreviewedDescriptors = await getUnreviewedDescriptors();
            comp.setState({unreviewedDescriptors: unreviewedDescriptors});
        }
        LoadData(this);
    }

    render() {
        if (this.state.unreviewedDescriptors == null) {
            return <LoadingPage pageTitle="Manage Submissions" />;
        }

        return (<>
            <PageTitle>Manage Submissions</PageTitle>
            <Center>
                {/* <Text>{JSON.stringify(this.state.unreviewedDescriptors)}</Text> */}
                <VStack w='100%' maxW="1000">
                    {/* <Flex w='100%'  alignItems='right' gap='2'>
                        <Spacer/>
                        <NavButton to='/compose' colorScheme='green' text="Add New Post"/>
                    </Flex> */}
                    <Spacer p={10}/>
                    <Heading>Team Photos</Heading>
                    <Box w='100%' ml={20} mr={20} mb={20} maxW="1000">
                        <DescriptorsTable imageDescriptors={this.state.unreviewedDescriptors} />
                    </Box>
                    {/* <Spacer p={10}/>
                    <Heading>News</Heading>
                    <Box w='100%' ml={20} mr={20} mb={20} maxW="1000">
                        <PostsTable posts={this.state.data.Posts.filter(p => p.type == 'News')} />
                    </Box> */}
                </VStack>
            </Center>
        </>)
    }
}

export default ManageSubmissions;